import CirgsCustomersList from './CirgsCustomersList';

export default CirgsCustomersList;
